import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
// import moment from 'moment';

interface DeliveryInventoryFormState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    zone: any;
    reserves: any[];
    targetForDelete: any[]; 
}

const state: DeliveryInventoryFormState = {
    loading: false,
    loaded: false,
    fatalError: false,

    zone: null,
    reserves: [],
    targetForDelete: [],
    
};

const initState = JSON.parse(JSON.stringify(state));

export const DEAL_DATA = 'GET_DEAL_DATA';
export const DEAL_SCHEMA = 'GET_DEAL_SCHEMA';
export const SELECT_ROLES_OP = 'SELECT_ROLES_OP';
export const SELECT_GRANTS_OP = 'SELECT_GRANTS_OP';

function getReserverItem(zone: any, itemData: any) {
    return {
      id: itemData ? itemData.id : null,
      delivery_instance_id: itemData ? itemData.delivery_instance_id : zone.instance_id,
      product_id: itemData ? itemData.product_id : null,
      product_container_id: itemData ? itemData.product_container_id : null,
      container_quantity: itemData ? itemData.container_quantity : null,
    };
}


export const actions: ActionTree<DeliveryInventoryFormState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    init({ commit, dispatch }, params) {
        return dispatch('loadData', params);
    },

    loadData({ commit, getters, dispatch }, { zone }) {
        const vm = (this as any)._vm;

        state.zone = zone;
        state.reserves = zone.reserves.filter((reserve: any) => reserve.id)

        commit('LOADED_SUCCESS');
        // this.reserves = data.zone.reserves.filter(reserve => reserve.id);

        // data.products$.subscribe(products => this.products = products)
        // data.variants$.subscribe(variants => this.variants = variants)
        // return new Promise((resolve, reject) => {
        //     commit('START_LOADING');

        //     vm.$db([

        //     ]).then((result: ServerResult) => {
        //         commit('SET_FORM_DATA', );

        //         commit('LOADED_SUCCESS');
        //         resolve();
        //     })
        //     .catch((error: any) => {
        //         console.log('error', error)
        //         commit('LOADED_ERROR');
        //         reject()
        //     })
        // })
    },

    addItem({ state }) {
        state.reserves.push(
            getReserverItem(state.zone, null)
        )
    },
    
    removeItem({ state }, index: number) {
        if (state.reserves[index].id) {
            state.targetForDelete.push(state.reserves[index].id)
        }

        state.reserves.splice(index, 1);
    },

    changeFormValue({ state }, { index, field, newValue}) {
        state.reserves[index][field] = newValue;
    },

    saveForm({ commit, state }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const queryNames: any[] = [];
            const querySources: any = {};

            const queries: any[] = state.reserves.map((reserve: any, index: number) => {
                queryNames.push(`SAVE_RESERVE_${index}`);
                querySources[`SAVE_RESERVE_${index}`] = reserve;

                const $reserve = cloneDeep(reserve);
                $reserve.container_quantity = parseInt($reserve.container_quantity);
                delete $reserve.product_id;

                if ($reserve.id) {
                    return vm.$q(`SAVE_RESERVE_${index}`).update($reserve.id, $reserve)
                } else {
                    return vm.$q(`SAVE_RESERVE_${index}`).create('s:delivery_instance_product_reserves', $reserve)
                }
            })

            for (const index in state.targetForDelete) {
                queries.push(
                    vm.$q(`DELETE_RESERVE_${index}`)
                        .raw('documents.delete')
                        .action({
                            id: state.targetForDelete[index]
                        })
                )
            }

            vm.$db(queries)
                .then((result: ServerResult) => {
                    state.reserves = queryNames.map((queryName: string) => {
                        const res = result.getOperation(queryName).getContent().document;

                        return getReserverItem(state.zone, {
                            ...res,
                            product_id: querySources[queryName].product_id
                        })
                    })

                    state.targetForDelete = [];

                    commit('LOADED_SUCCESS');
                    resolve();
                })
                .catch((error: any) => {
                    console.log('errror', error);

                    commit('LOADED_SUCCESS');
                    reject();
                });
        })
    },
};

export const mutations: MutationTree<DeliveryInventoryFormState> = {
    RESET_STATE: (state) => {
        for(const key in initState) {
            (state as any)[key] = initState[key]
        }
    },
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

};

const getters = {

};

export const STORE_KEY = '$_delivery_inventory_form';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
